import { FC, useMemo, useState } from 'react';
import { useStyles, BootstrapInput } from './styles';
import { useQuery } from 'react-query';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { GridColumns, DataGrid, GridRowParams, GridSortDirection, GridCellParams } from '@material-ui/data-grid';
import { Grid, Paper, Select, MenuItem, Checkbox, ListItemText } from '@material-ui/core';
import { DateRangePicker } from 'components/DateRangePicker';
import { Search } from 'components/Search';
import { observer } from 'mobx-react-lite';
import { capitalizeFirstLetter, toFormatDate, toFormatSum } from 'utils';
import { filterGroupsList } from './filterGropsList';
import Calender from './../../../assets/icons/EndUser/Calender.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
export const PaymentsTable: FC = observer(() => {
  const classes = useStyles();

  const {
    paymentsTableStore: {
      getPayments,
      setFilter,
      dateRangeFilter,
      showAllDateRange,
      setDateRangeFilter,
      groupFilter,
      setGroupFilter,
      getRenderValueForGroupSelect,
      paymentsView,
    },
    notificationStore: { openNotification },
  } = useStore();

  const getPaymentsReq = useQuery('getPaymentsReq', () => getPayments(), {
    onError: () => openNotification('error', `Can't get payments`),
  });

  useAppPreloader(getPaymentsReq.isFetching);
  const rows = useMemo(() => {
    return !getPaymentsReq.isFetching ? paymentsView : [];
  }, [getPaymentsReq.isFetching, paymentsView]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'subscriptionPaymentDate',
      headerName: 'LICENSE PURCHASED',
      flex: 0.7,
      renderCell: (params: GridCellParams) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          {' '}
          <img src={Calender} alt='' color='grey' />
          {toFormatDate(params.row.subscriptionPaymentDate)}
        </div>
      ),
    },
    {
      field: 'subscriptionExpirationDate',
      headerName: 'LICENSE RENEWS',
      flex: 0.7,
      renderCell: (params: GridCellParams) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          {' '}
          <img src={Calender} alt='' />
          {params.row.subscriptionExpirationDate === '30-day trial'
            ? params.row.subscriptionExpirationDate
            : toFormatDate(params.row.subscriptionExpirationDate)}
        </div>
      ),
    },
    {
      field: 'noOfUsers',
      headerName: 'LICENSE INFO',
      flex: 0.7,
      renderCell: (params: GridCellParams) => (
        <p>
          {params.row.noOfUsers === 1
            ? params.row.noOfUsers + ' User'
            : params.row.noOfUsers
            ? params.row.noOfUsers + ' Users'
            : null}{' '}
        </p>
      ),
    },
    {
      field: 'status',
      headerName: 'STATUS',
      flex: 0.5,
      renderCell: (params: GridCellParams) => (
        <p style={{ color: params.value === 'pending' ? '#FFD700' : params.row.status === 'paid' ? 'green' : 'red' }}>
          {capitalizeFirstLetter(params.row.status)}
        </p>
      ),
    },
    {
      field: 'amount',
      headerName: 'AMOUNT(USD)',
      flex: 0.6,
      renderCell: (params: GridCellParams) => <p>${toFormatSum(params.row.amount)}</p>,
    },
  ];

  return (
    <>
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <div className={classes.flex}>
          <DateRangePicker
            initialRange={dateRangeFilter}
            customRanges={[
              { label: 'Show All', startDate: showAllDateRange.startDate, endDate: showAllDateRange.endDate },
            ]}
            onChange={setDateRangeFilter}
          />
          <Select
            className={classes.select}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
            }}
            displayEmpty
            multiple
            //defaultValue={filterGroups}
            value={groupFilter}
            onChange={setGroupFilter}
            renderValue={groupFilter.length !== 0 ? getRenderValueForGroupSelect : () => <div>Select</div>}
            input={<BootstrapInput />}>
            {filterGroupsList.map((group) => (
              <MenuItem key={group} value={group} style={{ background: 'none' }}>
                <Checkbox checked={groupFilter.findIndex((item) => item === group) > -1} className={classes.checkbox} />
                <ListItemText primary={`${capitalizeFirstLetter(group)}`} />
              </MenuItem>
            ))}
          </Select>
        </div>
        <div>
          <Search handelSearch={setFilter} />
        </div>
      </Grid>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          disableSelectionOnClick
          getRowClassName={(params: GridRowParams) => `row-background-${params.getValue('status')}`}
          sortingOrder={['desc', 'asc']}
          sortModel={[
            {
              field: 'subscriptionPaymentDate',
              sort: 'desc' as GridSortDirection,
            },
          ]}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
    </>
  );
});
